import { setNotification } from '../hookState/NotifcationState';
import APIURLConstants from '../config/config';
import ApiHelper from './ApiHelper';
import Helper from './helper';

export const getAppNotificationCount = () => {
    const userInfo = Helper.getStorage('userInfo');
    const agentInfo = Helper.getStorage('agentInfo');
    const gAgentInfo = Helper.getStorage('agentUser');
    const agentConnection = Helper.getStorage('agentConnections');
    if (userInfo || agentInfo) {
        ApiHelper.get(
            APIURLConstants.GET_APP_NOTIFICATION_COUNT(
                agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.userID
            )
        )
            .then((res) => {
                setNotification({ notificationCount: res.data });
            })
            .catch((err) => {
                console.log(err);
            });
    }
};